module.exports = __webpack_public_path__ + "assets/secondary-icon-active.ee0ed07b.svg";